import { useCampaignParents } from '../../../useCampaignParents';
import { CampaignOverviewMetrics } from '../../../components/CampaignOverviewMetrics/CampaignOverviewMetrics';
import { dashboardT } from '../../../../../lib/messages';
import { useState } from 'react';
import { useAgencyCampaignContext } from '../../../agencyCampaignContext';
import { CampaignDetailsLayout } from '../../../CampaignDetailsLayout/CampaignDetailsLayout';
import { brandDetailsLink, campaignListLink } from '../../../hierarchyLinks';
import { ShigoPermission } from '../../../../auth/permissions';
import { useShigoPermissions } from '../../../../auth/useShigoPermissions';
import { useCampaignQuery } from '../../hooks';
import { CampaignDialog } from '../CampaignDialog';
import { LineItemsTable } from '../LineItemsTable';

export function CampaignOverviewPage({ campaignId }: { campaignId: string }) {
  const scope = useAgencyCampaignContext();
  const { can } = useShigoPermissions();
  const canWrite = Boolean(scope) || can(ShigoPermission.MadBuyCampaignWrite);
  const campaign = useCampaignQuery(campaignId);
  const [editOpen, setEditOpen] = useState(false);
  const brandId = campaign.data?.brandId ?? campaign.data?.brand?.id;
  useCampaignParents(brandId ?? '');
  const back = brandId
    ? brandDetailsLink(brandId, scope?.agency.id)
    : campaignListLink(scope?.agency.id);
  return (
    <>
      <CampaignDetailsLayout
        loadingLabel={dashboardT('campaigns.loadingDetails')}
        errorLabel={dashboardT('campaigns.loadDetailsError')}
        backLabel={brandId ? dashboardT('common.back') : dashboardT('campaigns.back')}
        name={campaign.data?.name}
        loading={campaign.isLoading}
        error={campaign.isError || !campaign.data}
        back={back}
        onEdit={
          canWrite
            ? () => {
                setEditOpen(true);
              }
            : undefined
        }
      >
        <CampaignOverviewMetrics filter={{ msCampaignIds: [campaignId] }} />
        <LineItemsTable campaignId={campaignId} />
      </CampaignDetailsLayout>
      {canWrite && editOpen && campaign.data ? (
        <CampaignDialog
          campaign={campaign.data}
          onClose={() => {
            setEditOpen(false);
          }}
        />
      ) : null}
    </>
  );
}
